// client/src/components/layout/AcessoNegado.js
import React from 'react';
import { ShieldAlert } from 'lucide-react';

const AcessoNegado = () => {
    return (
        <div className="flex flex-col items-center justify-center h-full text-center p-8">
            <ShieldAlert size={60} className="text-red-500 mb-4" />
            <h1 className="text-3xl font-bold mb-2">Acesso Negado</h1>
            <p className="text-gray-600 text-lg">
                Você não tem o nível de permissão necessário para visualizar esta página.
            </p>
        </div>
    );
};

export default AcessoNegado;